<template>
  <v-col cols="12" sm="6" lg="3">
    <v-card :loading="loading" class="mx-auto" height="180">
      <v-card-text class="text-h6 font-weight-black card-indicador-titulo">
        Matrículas Totais
      </v-card-text>

      <v-card-text class="text-h4 font-weight-black card-indicador-valor d-flex align-center py-0">
        <span>{{ qtd ?? 0 }}</span>

        <div class="card-indicador-grafico ml-auto">
          <apexchart type="area" height="72" :options="chartOptions" :series="series"></apexchart>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "MatriculasTotaisCard",
  props: {
    franquiaId: {
      type: Number,
    },
  },
  mounted() {
    this.getQtd(this.franquiaId);
  },
  watch: {
    franquiaId(value) {
      this.getQtd(value);
    },
  },
  data() {
    return {
      qtd: 0,
      loading: true,
      series: [
        {
          name: "Matrículas",
          data: [80, 88, 55, 88, 80, 88, 55, 88, 80, 88, 55, 88],
        },
      ],
      chartOptions: {
        chart: {
          height: 72,
          type: "area",
          toolbar: {
            show: false,
          },
          sparkline: {
            enabled: true,
          },
        },

        dataLabels: {
          enabled: false,
        },

        grid: {
          show: false,
        },

        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            // stops: [0, 90, 100],
          },
        },

        yaxis: {
          show: false,
        },

        responsive: [
          {
            breakpoint: 200,
            options: {
              legend: {
                position: "top",
                offsetY: -80,
              },
            },
          },
        ],

        xaxis: {
          labels: {
            show: false,
          },
          categories: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
          ],
        },
      },
    };
  },
  methods: {
    async getQtd(franquiaId) {
      if (!franquiaId) return;

      this.loading = true;
      try {
        const response = await this.$services.matriculasService.qtdTotal(franquiaId);

        this.qtd = response.qtd;
        this.series = [
          {
            name: "Matrículas",
            data: response.metricasPorMes.map((mes) => mes.qtd),
          },
        ];
      } catch (error) {
        this.$handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.card-indicador-titulo {
  min-height: 96px;
}

.card-indicador-valor {
  height: 72px;
  white-space: nowrap;
}

.card-indicador-grafico {
  flex: 0 0 96px;
  max-width: 96px;
}
</style>
